import $ from 'jquery';
import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';
import { DeterministicView, helpers } from '@bingads-webui/deterministic-view';
import { withUiBlock } from '@bingads-webui/uiblocker';
import template from './subaccount-bid-edit-template.pug';
import { BidStrategyView, EditPanelView, instrumentation, lightDismissible } from '../hotel-center-shared';

const i18n = globalContext.require('@bingads-webui/i18n-amd-loader!campaignui/feature/hotel-center');
const config = globalContext.require('component/config/index');
const decimal = globalContext.require('component/humanize/decimal');
const { showError } = globalContext.require('component/toast/index');

lightDismissible();

/**
 * Class representing a navigation tabs for SubAccount Edit Panel
 * @extends Backbone.View
 */
export default class SubAccountBidEdit extends DeterministicView {
  /**
   * Initializes SubAccountBidEdit
   * @returns {undefined}
   */
  initialize({
    subAccountModel,
  }) {
    this.i18n = i18n;
    this.subAccountModel = subAccountModel;

    this.bidStrategyView = new BidStrategyView({
      allowEmptyStrategy: false,
      isReadonly: false,
    });

    this.setChild('bid-strategy-view-container', this.bidStrategyView);

    this.editPanelView = new EditPanelView();
    this.setChild('edit-panel-view', this.editPanelView);
    this.editPanelView.on('saved', () => {
      this.onSave();
    }, this);
    this.editPanelView.on('canceled', () => {
      this.toggleVisibility();
    }, this);

    this.subAccountModel.fetch().then(() => {
      this.updateBidStrategyView();
      helpers.updateView(this, {
        amount: this.getBidText(),
      });
    });

    this.subAccountBarScenario = instrumentation.subAccountBar.create();
  }

  get template() {
    return template;
  }

  toggleVisibility() {
    this.$('.light-dismissible').toggleClass('show');
  }

  onSave() {
    if (!this.getChild('bid-strategy-view-container').getState().isValid) {
      return;
    }

    this.subAccountModel.set(
      'Bid',
      this.getChild('bid-strategy-view-container').getState().bid
    );

    const saveSubAccountBidActivity = this.subAccountBarScenario.saveSubAccountBid.create();

    saveSubAccountBidActivity.monitorAsync(this.subAccountModel
      .save(['Bid'], { patch: true }))
      .then(() => {
        const bidText = this.getBidText();

        helpers.updateView(this, {
          amount: bidText,
        });

        this.toggleVisibility();

        this.trigger('bid-changed', bidText);

        saveSubAccountBidActivity.trace('Sub-account bid is saved');
      })
      .catch(() => {
        showError(i18n.getString('GenericErrorMessage'));
      })
      .finally(withUiBlock($('.hotel-center-overview-container')));
  }

  getBidText() {
    if (!this.subAccountModel.get('Bid')) {
      return '';
    }

    if (this.subAccountModel.get('Bid')['@odata.type'] === '#Model.FixedBid') {
      return `${i18n.formatDecimalToFixed(this.subAccountModel.get('Bid').Amount)} ${config.get('AccountCurrencyCode')}`;
    }
    return `${i18n.formatDecimalToFixed(this.subAccountModel.get('Bid').Amount)} ${decimal.getFormat().percentSymbol}`;
  }

  updateBidStrategyView() {
    if (!this.subAccountModel.get('Bid')) {
      return;
    }

    const bidAmount = this.subAccountModel.get('Bid').Amount;

    if (this.subAccountModel.get('Bid')['@odata.type'] === '#Model.PercentageBid') {
      this.getChild('bid-strategy-view-container').setState({ bidStrategy: 'percentage', bidAmount });
    } else if (this.subAccountModel.get('Bid')['@odata.type'] === '#Model.PayPerStayBid') {
      this.getChild('bid-strategy-view-container').setState({
        bidStrategy: 'payperstay',
        bidAmount,
        isReadonly: true,
      });
    } else {
      this.getChild('bid-strategy-view-container').setState({ bidStrategy: 'fixed', bidAmount });
    }
  }
}
